var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.1 94.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e3e80;}.cls-2{fill:none;stroke:#59ac31;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.63px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.23,58.62c-6.04,0-10.95,5.05-10.95,11.25,0,1.38,.25,2.72,.7,3.94,.53,1.45,1.35,2.77,2.38,3.87,1.98,2.12,4.78,3.43,7.87,3.43s5.9-1.33,7.88-3.45c1.03-1.09,1.86-2.4,2.38-3.85,.46-1.23,.7-2.56,.7-3.94,0-6.2-4.92-11.25-10.97-11.25Zm6.88,15.19c-1.33,2.5-3.92,4.2-6.88,4.2s-5.54-1.7-6.88-4.2c-.61-1.14-.96-2.47-.98-3.87v-.07c0-4.5,3.54-8.16,7.87-8.16s7.88,3.66,7.88,8.16v.09c-.02,1.4-.37,2.72-1,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.05,94.1C21.11,94.1,0,72.99,0,47.05S21.11,0,47.05,0s47.05,21.11,47.05,47.05-21.11,47.05-47.05,47.05Zm0-90.72C22.97,3.38,3.38,22.97,3.38,47.05s19.59,43.67,43.67,43.67,43.67-19.59,43.67-43.67S71.13,3.38,47.05,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.29,21.26c0-.72,.58-1.3,1.3-1.3s1.3,.58,1.3,1.3v28.39c0,.72-.58,1.3-1.3,1.3s-1.3-.58-1.3-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.57,46.61c0,2.24-1.81,4.05-4.05,4.05s-4.05-1.81-4.05-4.05,1.81-4.05,4.05-4.05,4.05,1.81,4.05,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.29,46.61c0,2.24-1.81,4.05-4.05,4.05s-4.05-1.81-4.05-4.05,1.81-4.05,4.05-4.05,4.05,1.81,4.05,4.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 48.27,
    y1: 14.12,
    x2: 48.07,
    y2: 8.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.99,
    y1: 15.31,
    x2: 40.01,
    y2: 11.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.44,
    y1: 11.94,
    x2: 52.46,
    y2: 15.31
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShocked);
export default __webpack_public_path__ + "static/media/Shocked.3d82806f91dffe35aa20c71b453a0740.svg";
export { ForwardRef as ReactComponent };